import React from 'react'
import {
  Route,
} from 'react-router'

/** Route pages */
import Populator from 'populators/Signup'

const Signup = () => {
  const Routes = () => (
    <Route path="/signup" component={Populator.components.Signup} />
  )

  return Routes()
}

export default Signup
